import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthQuery } from './auth.query';
import { Logger } from '@core';

const log = new Logger('SuperuserGuard');

/**
 * Blocks transfer-edit / mandate-edit when global Demo-Mode (settings DEMO_MODE) is on.
 */
@Injectable({
  providedIn: 'root',
})
export class SuperuserGuard implements CanActivate {
  constructor(private router: Router, private authQuery: AuthQuery) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authQuery.editingAllowed) {
      return true;
    }

    log.debug(`demo mode active, blocking ${state.url}`);
    this.router.navigate(['/error-404'], { replaceUrl: true });
    return false;
  }
}
